import api from './api';

export interface Laboratorio {
  id: number;
  nombre: string;
  razon_social?: string;
  cuit?: string;
  direccion?: string;
  ciudad?: string;
  provincia?: string;
  email?: string;
  telefono?: string;
  estado?: number;
  p_busqueda?: boolean;
  p_carga?: boolean;
  p_modif_analisis?: boolean;
  p_nuevo_analisis?: boolean;
  p_pendientes?: number;
  fecha_registro?: string;
  fecha_actualizacion?: string;
}

// Obtener todos los laboratorios activos (estado = true)
export const getLaboratorios = async (): Promise<Laboratorio[]> => {
  // Sin datos de ejemplo de respaldo: un listado inventado haría asignar un
  // laboratorio que no existe.
  const response = await api.get('/laboratorios', {
    params: { estado: true }
  });
  return response.data;
};

// Obtener un laboratorio por ID
export const getLaboratorioById = async (id: number): Promise<Laboratorio | null> => {
  try {
    const response = await api.get(`/laboratorios/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener laboratorio con ID ${id}:`, error);
    return null;
  }
};

// Crear un nuevo laboratorio
export const createLaboratorio = async (laboratorio: Laboratorio): Promise<Laboratorio> => {
  const response = await api.post('/laboratorios', laboratorio);
  return response.data;
};

// Actualizar un laboratorio
export const updateLaboratorio = async (id: number, laboratorio: Partial<Laboratorio>): Promise<Laboratorio> => {
  const response = await api.put(`/laboratorios/${id}`, laboratorio);
  return response.data;
};

// Desactivar un laboratorio sin eliminarlo.
export const desactivarLaboratorio = async (id: number): Promise<void> => {
  await api.patch(`/laboratorios/${id}`, { estado: 1 });
};

// Eliminar un laboratorio. La baja es lógica: el laboratorio y todos sus
// usuarios pasan a estado 2, dejan de verse en la aplicación y el historial de
// análisis se conserva.
export const eliminarLaboratorio = async (id: number): Promise<void> => {
  await api.delete(`/laboratorios/${id}`);
}; 